import Layer2 from './Base';

export default function Database({ session }) {
  return <Layer2 page="Data" />;
}
